export const dataQuality = {
  eyebrow: "Data Quality & Hygiene",
  title: "Precision data.",
  highlight: "Zero junk records.",
  description:
    "Raw data decays at roughly 30% a year. Our real-time validation pipeline sanitizes, de-duplicates, and verifies every record before it reaches your CRM or outbound sales queue.",
  quote:
    "\"High-volume outreach with bad contact data only burns domains and exhausts sales reps. Clean verification is where ROI actually starts.\"",
  stats: [
    { label: "Verification Accuracy", value: "85%" },
    { label: "Bounce Rate Target", value: "< 2.0%" },
    { label: "Records Cleansed Daily", value: "1.2M+" },
  ],
};